module.exports = __webpack_public_path__ + "static/media/6.0b6ef4fc.jpg";